import Icon from '../ui/Icon';
import { levelStyle } from './couponAdapter';

/** "Standard N-Tier Driver Milestone Schema": tiers come from the API (read-only; there's no API to edit them). */
export default function TierCards({ tiers, loading }) {
  return (
    <section className="bg-surface-container-lowest rounded-xl border border-outline-variant/30 shadow-xs p-4 flex flex-col 2xl:flex-row 2xl:items-center justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-11 h-11 rounded-lg bg-surface-container-low flex items-center justify-center text-primary-container shrink-0">
          <Icon name="military_tech" size={24} />
        </div>
        <div className="min-w-0">
          <h2 className="flex items-center gap-1.5 text-base font-bold text-primary">
            Standard {tiers.length || 4}-Tier Driver Milestone Schema
            <span
              className="inline-flex items-center gap-0.5 px-1.5 rounded-full bg-surface-container text-[10px] font-semibold text-on-surface-variant cursor-help"
              title="Scan targets and tier names are managed by the backend and can't be edited here yet."
            >
              <Icon name="info" size={12} />
              Managed by backend
            </span>
          </h2>
          <p className="text-xs text-on-surface-variant">Progressive scan unlocks rewarding crowdsourced driver receipt reporting.</p>
        </div>
      </div>

      <ul
        className="grid grid-cols-2 sm:grid-cols-[repeat(var(--tiers),minmax(0,1fr))] gap-2 2xl:max-w-3xl flex-1"
        style={{ '--tiers': Math.max(1, tiers.length || 4) }}
        aria-label="Reward tiers"
      >
        {loading
          ? Array.from({ length: 4 }, (_, i) => <li key={i} className="h-14 rounded-lg bg-surface-container-low animate-pulse" />)
          : tiers.map((tier) => {
              const style = levelStyle(tier.level);
              return (
                <li key={tier.level} className={`bg-surface-container-low p-2.5 rounded-lg flex items-center gap-2 border-l-4 ${style.border}`}>
                  <span
                    className={`w-7 h-7 rounded-full ${style.badge} text-on-primary font-data-mono text-[11px] font-bold flex items-center justify-center shrink-0`}
                  >
                    L{tier.level}
                  </span>
                  <div className="min-w-0">
                    <div className="text-[13px] font-bold text-on-surface tabular whitespace-nowrap">{tier.scansRequired} Scans</div>
                    <div className="text-[11px] font-semibold text-on-surface-variant truncate">{tier.name}</div>
                  </div>
                </li>
              );
            })}
      </ul>
    </section>
  );
}
